<section class="coming-soon" dir="rtl">
  <div class="aurora aurora-1"></div>
  <div class="aurora aurora-2"></div>
  <div class="aurora aurora-3"></div>
  <div class="grid-glow"></div>

  <div class="content-shell centered-shell">
    <div class="info-panel glass-panel reveal-up centered-panel">
      <div class="brand-mark pulse-ring">
        <img src="assets/images/logoneew.png" alt="رفيق دربك" class="brand-logo" />
      </div>

      <div class="status-row centered-status mt-2">
        <span class="status-dot"></span>
        <span>قريباً جداً</span>
      </div>

      <span class="eyebrow" style="margin-right: 20px;">تجربة رقمية قادمة</span>
      <h1  style="padding-bottom: 30px;">رفيق دربك</h1>
      <h2>وَذَكِّرْ فَإِنَّ الذِّكْرَى تَنْفَعُ الْمُؤْمِنِينَ</h2>

<div class="links-block">
  <div class="links-title">روابطنا • Our Links</div>

  <div class="links-grid">
    <!-- Instagram -->
    <a
      class="social-icon"
      href="https://www.instagram.com/p/DTqIpNrjBhz/?igsh=MWhmdGk3aGg2d29zOQ=="
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
      title="Instagram"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5Zm8.88 1.63a1.12 1.12 0 1 1 0 2.24 1.12 1.12 0 0 1 0-2.24ZM12 6.5A5.5 5.5 0 1 1 6.5 12 5.5 5.5 0 0 1 12 6.5Zm0 1.5A4 4 0 1 0 16 12a4 4 0 0 0-4-4Z"/>
      </svg>
    </a>

    <!-- Facebook -->
    <a
      class="social-icon"
      href="https://www.facebook.com/share/18QD57ojtX/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Facebook"
      title="Facebook"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M13.5 22v-8h2.7l.4-3h-3.1V9.1c0-.9.3-1.6 1.6-1.6h1.7V4.8c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4V11H8v3h2.6v8h2.9Z"/>
      </svg>
    </a>

    <!-- App Store (Apple) -->
<a
  class="social-icon"
  href="https://apps.apple.com/us/app/%D8%B1%D9%81%D9%8A%D9%82-%D8%AF%D8%B1%D8%A8%D9%83/id6757695249"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="App Store"
  title="App Store"
>
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.4 13.7c0-2.1 1.7-3.1 1.8-3.2-1-1.5-2.6-1.7-3.2-1.7-1.4-.1-2.7.8-3.4.8-.7 0-1.8-.8-2.9-.8-1.5 0-2.9.9-3.7 2.2-1.6 2.8-.4 6.9 1.2 9.2.8 1.1 1.7 2.3 2.9 2.3 1.2 0 1.6-.8 3-0.8 1.4 0 1.8.8 3 .8 1.2 0 2-.1 2.9-2.3.6-.9 1-1.8 1.1-1.9-.1 0-2.1-.8-2.1-3.6ZM13.9 7.2c.6-.7 1-1.7.9-2.7-.9 0-2 .6-2.6 1.3-.6.7-1.1 1.7-1 2.6 1 .1 2-.5 2.7-1.2Z"/>
  </svg>
</a>
    <!-- Google Play -->
    <a
      class="social-icon"
      href="https://play.google.com/store/apps/details?id=com.rafeek_eldarb.app&hl=ar"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Google Play"
      title="Google Play"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M3.5 3.8c-.3.3-.5.8-.5 1.4v13.6c0 .6.2 1.1.5 1.4l9.2-9.2-9.2-9.2Zm10.4 10 2.5 2.5 3.8-2.2c1-.6 1-1.8 0-2.4L16.4 9l-2.5 2.5ZM4.8 21 15 15 12.9 13 4.8 21Zm0-18 8.1 8L15 9 4.8 3Z"/>
      </svg>
    </a>

    <!-- TikTok -->
    <a
      class="social-icon"
      href="https://vt.tiktok.com/ZSaRqeToX/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="TikTok"
      title="TikTok"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M14.5 3c.5 2.2 1.8 3.8 4 4.4v2.5c-1.4 0-2.7-.4-3.9-1.2v5.4a5.7 5.7 0 1 1-5.7-5.7c.4 0 .8 0 1.2.1v2.8a2.8 2.8 0 1 0 1.6 2.5V3h2.8Z"/>
      </svg>
    </a>
  </div>
</div>



    </div>
  </div>

  <div class="orbits">
    <span class="orbit orbit-1"></span>
    <span class="orbit orbit-2"></span>
    <span class="orbit orbit-3"></span>
  </div>
</section>
